import { api } from './api';
import { UserEntity } from './userApi';

/** Same envelope every sign-in path returns (see server AuthController). */
export interface AuthEnvelope {
  accessToken: string;
  refreshToken: string;
  user: UserEntity;
  isNewUser: boolean;
}

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    googleSignIn: builder.mutation<AuthEnvelope, { idToken: string }>({
      query: (body) => ({
        url: '/auth/google',
        method: 'POST',
        body,
      }),
    }),
    refreshSession: builder.mutation<AuthEnvelope, { refreshToken: string }>({
      query: (body) => ({
        url: '/auth/refresh',
        method: 'POST',
        body,
      }),
    }),
    revokeSession: builder.mutation<{ ok: boolean }, { refreshToken: string }>({
      query: (body) => ({
        url: '/auth/logout',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGoogleSignInMutation,
  useRefreshSessionMutation,
  useRevokeSessionMutation,
} = authApi;
